import Vue from "vue";
import VueRouter from "vue-router";
import DASHBOARD_ROUTE from "@/modules/dashboard/routes/routes.js";
import HOMEPAGE_ROUTE from "@/modules/homepage/routes/routes.js";
import { router as HEALTH_THINK_ROUTE } from "@/modules/healthThink";

Vue.use(VueRouter);

const routes = [
  ...HOMEPAGE_ROUTE,
  ...DASHBOARD_ROUTE,
  ...HEALTH_THINK_ROUTE,
  {
    path: "*",
    name: "NotFound",
    component: () => import("@/components/NotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
